

import React from "react";
import { Badge, InputGroup, Form, Button, Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";

const TooltipButton = ({ label, children }) => (
  <OverlayTrigger
    placement="top"
    overlay={<Tooltip>{label}</Tooltip>}
  >
    <span className="d-inline-block">
      {children}
    </span>
  </OverlayTrigger>
);

const TableHeader = ({
  title,
  icon,
  totalCount,
  totalLabel,
  filteredCount,
  showFiltered = false,
  searchPlaceholder = "Search...",
  searchValue,
  onSearchChange,
  showColumnVisibility = false,
  allColumns = [],
  visibleColumns = {},
  onToggleColumnVisibility,
  actionButtons = [],
  headerActions = [],
  showSearch = true,
}) => {
  return (
    <div
      className="d-flex justify-content-between align-items-center mb-4 p-2"
      style={{
        color: "var(--primary-color)",
        background: "var(--primary-background-color)",
        borderRadius: "10px",
      }}
    >

      <div className="d-flex align-items-center gap-3">
        <h5 className="fw-bold mb-1" style={{ color: "var(--primary-color)" }}>
          {icon && <i className={`${icon} me-2 fs-6`}></i>}
          {title}
        </h5>

        {/* {totalCount !== undefined && (
          <Badge bg="light" text="dark">
            <span className="detail-h3">
              Total: {totalCount}{" "}
              {totalLabel || (totalCount === 1 ? "Item" : "Items")}
            </span>
          </Badge>
        )} */}

        {showFiltered && filteredCount !== undefined && (
          <Badge bg="info">
            <i className="fa-solid fa-filter me-1"></i>
            <span className="detail-h3">Filtered: {filteredCount}</span>
          </Badge>
        )}
      </div>

      <div className="d-flex gap-2 flex-wrap align-items-center detail-h3">

        {/* {showSearch && (
          <InputGroup size="sm" style={{ width: "250px", maxWidth: "100%" }}>
            <InputGroup.Text>
              <i
                className="fa-solid fa-search"
                style={{ color: "var(--primary-color)" }}
              ></i>
            </InputGroup.Text>
            <Form.Control
              placeholder={searchPlaceholder}
              value={searchValue || ""}
              onChange={(e) =>
                onSearchChange && onSearchChange(e.target.value)
              }
            />
          </InputGroup>
        )} */}

        {showColumnVisibility && allColumns.length > 0 && (
          <Dropdown>
            <TooltipButton label="Show / Hide Columns">
              <Dropdown.Toggle
                variant="outline-secondary"
                size="sm"
                className="custom-btn-table-header"
              >
                <i className="fs-7 fa-solid fa-gear"></i>
              </Dropdown.Toggle>
            </TooltipButton>

            <Dropdown.Menu
              align="end"
              style={{ minWidth: "200px", maxHeight: "400px", overflowY: "auto" }}
            >
              <Dropdown.Header className="detail-h3 fw-bold">
                Show / Hide Columns
              </Dropdown.Header>
              <Dropdown.Divider />

              {allColumns.map((col) => (
                <Dropdown.Item
                  key={col.field}
                  onClick={(e) => {
                    e.stopPropagation();
                    onToggleColumnVisibility &&
                      onToggleColumnVisibility(col.field);
                  }}
                >
                  <div className="d-flex align-items-center detail-h3">
                    <input
                      type="checkbox"
                      checked={visibleColumns[col.field] !== false}
                      onChange={() =>
                        onToggleColumnVisibility &&
                        onToggleColumnVisibility(col.field)
                      }
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        marginRight: "8px",
                        cursor: "pointer",
                      }}
                    />
                    <span>{col.label}</span>
                  </div>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )}


        {headerActions.length > 0 &&
          headerActions
            .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
            .map((action) => (
              <TooltipButton key={action.key} label={action.label || action.key}>
                <Button
                  variant={action.variant || "outline-primary"}
                  size={action.size || "sm"}
                  onClick={action.onClick}
                  style={action.style}
                  className="custom-btn-table-header"
                >
                  {action.icon && (
                    <i className={`${action.icon}`}></i>
                  )}
                </Button>
              </TooltipButton>
            ))}

        {actionButtons.map((btn, index) => (
          <TooltipButton key={index} label={btn.label}>
            <Button
              variant={btn.variant}
              size={btn.size}
              onClick={btn.onClick}
              style={btn.style}
              className="custom-btn-table-header "
            >
              <i className={btn.icon}></i>
            </Button>
          </TooltipButton>
        ))}
      </div>
    </div>
  );
};

export default TableHeader;
